import React, { useState } from 'react';
import {
  Stack,
  Container,
  Grid,
  ButtonGroup,
  Button,
  InputLabel,
  MenuItem,
  Select,
  Box,
  FormControl,
  TextField
} from '@mui/material';
import DealersService from '@api/Dealers/DealersCtrl';
import { FixNavbarSpace } from '../Utilities/Navbar';


type InputValue = {
      'Order Type': string,
      'SO.': string,
      'PO.': string,
      'Company': string,
      'Tag Name': string,
      'Make': string,
      'Model': string,
      'A': string,
      'B': string,
      'C': string,
      'D': string,
      'E': string,
      'F': string,
      'CUT SIDE': string,
      'TAPER': string,
      'Skirt': string,
      'Wrap': string,
      'Pillow': string,
      'Color': string,
      'Qty.': string,
      'Notes': string
};


const SpaCoverSummary = () => {
  // States para datos simples
  const [manufacturer, setManufacturer] = useState('');
  const [model, setModel] = useState('');
  const [year, setYear] = useState('');
  const [spaShape, setSpaShape] = useState('');
  const [foldType, setFoldType] = useState('');
  const [sizeTaper, setSizeTaper] = useState('');
  const [color, setColor] = useState('');
  const [notes, setNotes] = useState('');

  const handleCreateOrder = async () => {
    const order = {
      items: [
        {
          index: 0,
          quantity: 1,
          department: 'Design',
          tagName: 'Demo',
          inRush: false,
          safetyCover: {
            price: 1000,
            color: 'black',
            shapeType: 'rectangle',
            deckType: 'Concrete',
            coverType: 'standard mesh',
            rdm: "0'0\"",
            rrw: "0'0\"",
            perimeterPadding: "0'0\"",
            poolSizeExpression: "10 x 10",
            customDeck: {
              woodDeck: "0'0\"",
              gardenDeck: "0'0\"",
              interlockDeck: "0'0\""
            },
            gridType: "3x3",
            miscellaneous: {
              item: "",
              cost: 0
            },
            steps: {
              greaterThan8ft: 0,
              lesserThan8ft: 1
            },
            cutOuts: 0,
            cutCorners: 0,
            extraPaddings: 0,
            anchors: 2,
            coverSqFt: "100",
            poolLinearFt: 40
          }
        }
      ],
      dealerId: 'Tu9mSbHuvryXARHYX', // ⚠️ usa uno real
      customerPO: 'Demo PO',
      dueDate: new Date(),
      customerPickup: true,
      contactNameForPickup: 'Juan Pérez',
      billingAddress: {
        firstname: 'Juan',
        lastname: 'Pérez',
        organization: 'Spa Covers Inc.',
        phone: '5551234567',
        address: 'Av. Reforma 123',
        city: 'CDMX',
        province: {
          long_name: 'Ciudad de México',
          short_name: 'CDMX'
        },
        zipCode: '01000'
      },
      shippingMethod: {
        method: 'Pickup',
        cost: 0
      },
      shippingAddress: {
        street: 'Av. Reforma 123',
        city: 'CDMX',
        state: 'CDMX',
        zip: '01000',
        country: 'MX'
      },
      status: 'InProduction',
      discount: 0,
      total: 1000
    };
  

    try {
      

      const inputValue: InputValue = {
      'Order Type': 'usagePurpose',
      'SO.': 'SO123456',
      'PO.': 'PO7890',
      'Company': 'organization',
      'Tag Name': 'tagName',
      'Make': 'Jacuzzi',
      'Model': 'J-300',
      'A': '78',
      'B': '78',
      'C': '10',
      'D': '10',
      'E': '',
      'F': '',
      'CUT SIDE': 'Left',
      'TAPER': '4-2',
      'Skirt': '4"',
      'Wrap': '3MIL',
      'Pillow': 'Standard',
      'Color': 'safetyCover.color',
      'Qty.': 'quantity',
      'Notes': 'Client requested rush order'
    };

    const formData = new FormData();
    Object.keys(inputValue).forEach((key) => {
        const value = inputValue[key as keyof InputValue];
        if (value !== undefined) {
            formData.append(key as keyof InputValue, value as string); // Solo agregamos valores no undefined
        }
    });
      const res = await fetch('https://script.google.com/macros/u/1/s/AKfycbyqNGy85YayQHlTH1qurAnAbfkJi5S87xbV1XA3Z-k3GBsZdcc12zJ3DMouJYpEpV6Log/exec', {
        method: 'POST',
        body: formData
    });

    if (res.ok) {
        console.log('Data was successfully submitted');
    } else {
        console.log('Error:', res);
    }
      console.log('Orden creada exitosamente:');
    } catch (error) {
      console.error('Error al crear orden:', error);
    }
  };
  

  return (
    <Stack minHeight="60vh" alignItems="center" spacing={5}>
      <FixNavbarSpace />
      <Container>
        <Grid container justifyContent="center">
          <Grid item xs={12} md={6} style={{ textAlign: 'center' }}>
            <FormControl fullWidth sx={{ mb: 2 }}>
              <TextField
                label="Spa Manufacturer"
                value={manufacturer}
                onChange={(e) => setManufacturer(e.target.value)}
              />
            </FormControl>

            <FormControl fullWidth sx={{ mb: 2 }}>
              <TextField
                label="Model"
                value={model}
                onChange={(e) => setModel(e.target.value)}
              />
            </FormControl>

            <FormControl fullWidth sx={{ mb: 2 }}>
              <TextField
                label="Year"
                value={year}
                onChange={(e) => setYear(e.target.value)}
              />
            </FormControl>

            <FormControl fullWidth sx={{ mb: 2 }}>
              <InputLabel>Spa Shape</InputLabel>
              <Select
                value={spaShape}
                label="Spa Shape"
                onChange={(e) => setSpaShape(e.target.value)}
              >
                <MenuItem value="Circle">Circle</MenuItem>
                <MenuItem value="Octagon">Octagon</MenuItem>
                <MenuItem value="Rectangle">Rectangle</MenuItem>
              </Select>
            </FormControl>

            <FormControl fullWidth sx={{ mb: 2 }}>
              <InputLabel>Fold Type</InputLabel>
              <Select
                value={foldType}
                label="Fold Type"
                onChange={(e) => setFoldType(e.target.value)}
              >
                <MenuItem value="Full">Full</MenuItem>
                <MenuItem value="BiFold">Bi-Fold</MenuItem>
              </Select>
            </FormControl>

            <FormControl fullWidth sx={{ mb: 2 }}>
              <InputLabel>Taper</InputLabel>
              <Select
                value={sizeTaper}
                label="Taper"
                onChange={(e) => setSizeTaper(e.target.value)}
              >
                <MenuItem value="4-2">4"-2"</MenuItem>
                <MenuItem value="5-3">5"-3"</MenuItem>
              </Select>
            </FormControl>

            <FormControl fullWidth sx={{ mb: 2 }}>
              <InputLabel>Color</InputLabel>
              <Select
                value={color}
                label="Color"
                onChange={(e) => setColor(e.target.value)}
              >
                <MenuItem value="Black">Black</MenuItem>
                <MenuItem value="Brown">Brown</MenuItem>
              </Select>
            </FormControl>

            <FormControl fullWidth sx={{ mb: 2 }}>
              <TextField
                label="Notes"
                multiline
                rows={3}
                value={notes}
                onChange={(e) => setNotes(e.target.value)}
              />
            </FormControl>

            <Button
              variant="contained"
              color="primary"
              onClick={handleCreateOrder}
            >
              Crear Orden
            </Button>
          </Grid>
        </Grid>
      </Container>
    </Stack>
  );
};

export default SpaCoverSummary;

